import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const gitguardian = defineConnector({
  identifier: "gitguardian",
  name: "GitGuardian",
  tagLine: "Code security and secrets detection",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://api\\.gitguardian\\.com/.*",
  auth: (app) =>
    headerAuth([
      {
        name: "Authorization",
        value: app.secret.personalAccessToken,
        scheme: "Token",
      },
    ]),
  steps: [
    {
      title: "Create a personal access token",
      items: [
        {
          kind: "markdown",
          content:
            "In GitGuardian, go to **API → Personal access tokens** and create a new token with the required scopes.",
        },
      ],
    },
    {
      title: "Paste your token",
      items: [
        {
          kind: "input",
          label: "Personal access token",
          required: true,
          target: { kind: "secrets", field: "personalAccessToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.gitguardian.com/v1/health",
  },
});
